import { MouseEvent } from 'react';
import { FOOTER_ID } from '../constants/dom';

export const scrollToFooter = (e?: MouseEvent) => {
  document.getElementById(FOOTER_ID)
    ?.scrollIntoView({ behavior: 'smooth' });

  e?.preventDefault();
};
